import 'react-image-lightbox/style.css';

import { Chip } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { isMobile } from 'react-device-detect';
import Lightbox from 'react-image-lightbox';
import { connect } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Modal, Spinner } from 'reactstrap';

import Breadcrumb from '@/components/common/breadcrumb.component';
import DebounceSearchBar from '@/components/debounce-search-bar';
import Icon from '@/components/icon';
import Pagination from '@/components/pagination';
import RowMoreOptions from '@/components/table/row-more-options';
import Placeholder from '@/config/placeholder.config';
import { Constants } from '@/constants';
import Cigar from '@/models/Cigar';
import {
  getAllCigars,
  getCigarMatchById,
  getCigarMatches,
} from '@/redux/actions/cigar.actions';
import { renderTimestamp } from '@/utils/formatting';
import { Resize } from '@/utils/imageUtils';

const defaults = {
  selectedMatchId: null,
  selectedCigar: '',
  photoIndex: 0,
  isOpen: false,
  error: {
    show: false,
    title: '',
    message: '',
  },
};

const CigarMatches = (props) => {
  const [state, setState] = useState({
    page: 1,
    sizePerPage: 12,
    showModal: false,
    submitting: false,
    alertUser: true,
    ...defaults,
  });

  const updateState = (updates) =>
    setState((prev) => ({ ...prev, ...updates }));

  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const fetchRequests = () => {
    if (searchParams?.has('id')) {
      props.getCigarMatchById(searchParams?.get('id'));
    } else {
      props.getCigarMatches(state.page, state.sizePerPage);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, [searchParams, state.page]);

  const keyForType = (type) => {
    switch (type) {
      case 'choose':
        return 'showModal';
      default:
        return '';
    }
  };

  const onOpenModal = (type, matchId) => {
    updateState({
      [keyForType(type)]: true,
      selectedMatchId: matchId,
    });
  };

  const onCloseModal = (type) => {
    updateState({
      [keyForType(type)]: false,
      ...defaults,
    });
  };

  const onSaveModal = (type) => {
    console.log('Submitting!');
    if (type === 'choose') {
      const { selectedMatchId, selectedCigar, alertUser } = state;
      console.log(`Match ID: ${selectedMatchId}`);
      console.log(`Cigar ID: ${selectedCigar}`);
      updateState({ submitting: true });
      axios
        .put(`${Constants.apiPath}/cigars/matches/${selectedMatchId}`, {
          id: selectedCigar.value,
          notify: alertUser,
        })
        .then(() => {
          updateState({
            [keyForType(type)]: false,
            submitting: false,
            ...defaults,
          });
          fetchRequests();
        })
        .catch((e) => {
          console.log(e.message);
          updateState({
            submitting: false,
            error: {
              show: true,
              title: 'Unable to update match information',
              message: e.message,
            },
          });
        });
    }
  };

  const handleChange = (key) => (value) => {
    updateState({ [key]: value });
  };

  const loadCigars = (inputValue) => {
    console.log(`Loading cigars for query "${inputValue}"`);
    props.getAllCigars(1, 20, inputValue);
    // setTimeout(() => {
    //   if (typeof callback === 'function') {
    //     callback(
    //       props.CigarManager.cigars.map((cigar) => {
    //         console.log(cigar);
    //         return {
    //           value: cigar.id,
    //           label: cigar.full_name,
    //           images: cigar.images,
    //         };
    //       })
    //     );
    //   }
    // }, 500);
  };

  const closeAlert = () => {
    updateState({
      error: { show: false, title: '', message: '' },
    });
  };

  const clearQueryParams = () => {
    navigate(location.pathname, { replace: true });
  };

  const chooserModal = () => (
    <Modal isOpen={state.showModal} onClosed={() => onCloseModal('choose')}>
      <div className="modal-header">
        <h5 className="modal-title">Choose Cigar</h5>
      </div>
      <div className="modal-body">
        <div>
          <input
            className="form-control sticky"
            placeholder="Search cigars..."
            onChange={(event) => loadCigars(event.target.value)}
          />
          <List>
            {props.CigarManager.cigars.length > 0 &&
              props.CigarManager.cigars.map((cigar) => (
                <ListItem
                  key={`cigar-item-${cigar.id}`}
                  onClick={() =>
                    updateState({
                      selectedCigar: {
                        value: cigar.id,
                        label: cigar.full_name.replace(' null', '').trim(),
                      },
                    })
                  }
                >
                  <Badge
                    color="secondary"
                    overlap="circle"
                    badgeContent={
                      <Icon
                        name="check"
                        style={{ margin: 0, height: 8, width: 8 }}
                      />
                    }
                    invisible={state.selectedCigar.value !== cigar.id}
                  >
                    <Avatar
                      variant={Cigar.getBandImage(cigar) ? 'square' : 'circle'}
                      src={Cigar.getBandImage(cigar)}
                      style={{ marginRight: 10, height: 80, width: 80 }}
                      alt={cigar.full_name}
                      imgProps={{ style: { objectFit: 'contain' } }}
                    >
                      <img
                        src={Placeholder.cigar}
                        style={{ height: 80, width: 80 }}
                      />
                    </Avatar>
                  </Badge>
                  <ListItemText
                    primary={
                      <span
                        className="padded-multiline"
                        style={{ marginLeft: 10 }}
                      >
                        {cigar.full_name.replace(' null', '').trim()}
                      </span>
                    }
                  />
                </ListItem>
              ))}
            {props.CigarManager.cigars.length === 0 && (
              <div style={{ textAlign: 'center', margin: 10 }}>
                No cigars found
              </div>
            )}
          </List>
        </div>
      </div>
      <div className="modal-footer">
        <Button color="light" onClick={() => onCloseModal('choose')}>
          Cancel
        </Button>
        <Button
          disabled={state.submitting}
          onClick={() => onSaveModal('choose')}
          variant="contained"
          color="primary"
        >
          {state.submitting && (
            <Spinner size="sm" color="light" style={{ marginRight: 8 }} />
          )}
          {state.submitting ? 'Matching...' : 'Match'}
        </Button>
      </div>
    </Modal>
  );

  const {
    pendingMatches,
    loadingMatches: loading,
    matchIdNotFound,
  } = props.CigarManager;

  return (
    <div>
      <SweetAlert
        show={state.error.show}
        type="danger"
        title={state.error.title}
        onConfirm={closeAlert}
      >
        {state.error.message}
      </SweetAlert>

      <Breadcrumb title="Pending Matches" parent="Manager" />

      <div
        className="container-fluid"
        style={{ marginTop: isMobile ? 30 : 'inherit' }}
      >
        {searchParams.get('id') && (
          <Chip
            size="small"
            label="Clear Filter"
            onClick={clearQueryParams}
            onDelete={clearQueryParams}
          />
        )}
        <DebounceSearchBar
          placeholder="Search users..."
          onChange={() => updateState({ page: 1 })}
          onSearch={() => {
            // TODO Filter matches based on user full_name or email
          }}
        />
        <div className="row">
          {loading && (
            <div
              style={{ textAlign: isMobile ? 'center' : 'left', width: '100%' }}
            >
              <div
                style={{ textAlign: isMobile ? 'center' : 'left', margin: 20 }}
              >
                Loading...
              </div>
            </div>
          )}
          {!loading && !matchIdNotFound && pendingMatches.length === 0 && (
            <div
              style={{ textAlign: isMobile ? 'center' : 'left', width: '100%' }}
            >
              <div
                style={{ textAlign: isMobile ? 'center' : 'left', margin: 20 }}
              >
                All caught up!
              </div>
            </div>
          )}
          {!loading && matchIdNotFound && (
            <div
              style={{ textAlign: isMobile ? 'center' : 'left', width: '100%' }}
            >
              <div
                style={{ textAlign: isMobile ? 'center' : 'left', margin: 20 }}
              >
                A match for this ID was not found
              </div>
              <Button
                onClick={clearQueryParams}
                variant="contained"
                color="secondary"
                style={{ marginLeft: isMobile ? 0 : 30 }}
              >
                Clear filter
              </Button>
            </div>
          )}
          {pendingMatches.map(
            (match, i) =>
              match.scan && (
                <div className="col-sm-12 col-md-6 col-lg-4 col-xl-3" key={i}>
                  <div
                    className="card height-equal"
                    style={{
                      height: 500,
                      margin: isMobile ? '0px -20px 20px' : '20px 15px',
                    }}
                  >
                    <div
                      className="card-header"
                      style={{ display: 'flex', padding: 5 }}
                    >
                      <Avatar
                        src={match.scan.user.image_url}
                        style={{ height: 28, width: 28, margin: '8px 12px' }}
                      >
                        {match.scan.user.first_name.charAt(0)}
                      </Avatar>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            fontWeight: 600,
                            color: '#2b2b2b !important',
                          }}
                        >
                          {`${match.scan.user.first_name} ${match.scan.user.last_name}`}
                        </div>
                        <div style={{ fontSize: 12 }}>
                          {match.matched && match.scan.cigar
                            ? `Matched as ${match.scan.cigar.full_name} - `
                            : 'Request sent'}{' '}
                          {renderTimestamp(match.timestamp)}
                        </div>
                      </div>
                      <RowMoreOptions
                        style={{ paddingTop: 10 }}
                        row={i}
                        items={[
                          {
                            type: 'MenuItem',
                            onClick: () => alert('Coming soon!'),
                            title: 'Request Better Photo',
                          },
                          {
                            type: 'MenuItem',
                            onClick: () => alert('Coming soon!'),
                            title: 'Request Purchase Location',
                          },
                          {
                            type: 'Divider',
                          },
                          {
                            type: 'MenuItem',
                            onClick: () => alert('Coming soon!'),
                            style: { color: '#ff4700' },
                            title: 'Delete',
                          },
                        ]}
                      />
                    </div>
                    <div
                      className="card-body native-image-bg"
                      style={{
                        backgroundImage: `url('${Resize.size(match.image_url, {
                          width: 500,
                          height: 500,
                          cropType: 'crop',
                        })}')`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                      }}
                      onClick={() => {
                        updateState({ photoIndex: i, isOpen: true });
                      }}
                    />
                    <div
                      style={{
                        display: match.matched ? 'block' : 'none',
                        position: 'absolute',
                        maxWidth: '100%',
                        top: 180,
                      }}
                    >
                      <img
                        src="https://cdn.boxpressd.io/assets/img/matched-stamp.png"
                        style={{
                          maxWidth: '100%',
                          transform: 'rotate(-45deg)',
                          filter:
                            'invert(12%) sepia(83%) saturate(4496%) hue-rotate(356deg) brightness(95%) contrast(79%)',
                        }}
                      />
                    </div>
                    <div className="card-footer">
                      <Button
                        color="primary"
                        onClick={() => onOpenModal('choose', match.id)}
                        style={{ width: '100%' }}
                      >
                        {'Choose Cigar'}
                      </Button>
                    </div>
                  </div>
                </div>
              )
          )}
        </div>
        <Pagination
          className="pagination-bar"
          currentPage={state.page}
          // FIXME How to get the total number of pending matches on the server?
          totalCount={100}
          pageSize={state.sizePerPage}
          additionalPagesToShow={isMobile ? 1 : 3}
          onPageChange={(page) => updateState({ page })}
          onDotsClick={() => {
            // TODO We can show a page picker
            console.log('Page picker clicked');
          }}
        />
      </div>
      {state.isOpen && (
        <Lightbox
          mainSrc={pendingMatches[state.photoIndex].image_url}
          nextSrc={
            pendingMatches[(state.photoIndex + 1) % pendingMatches.length]
              .image_url
          }
          prevSrc={
            pendingMatches[
              (state.photoIndex + pendingMatches.length - 1) %
                pendingMatches.length
            ].image_url
          }
          imageTitle={`${state.photoIndex + 1}/${pendingMatches.length}`}
          onCloseRequest={() => updateState({ isOpen: false })}
          onMovePrevRequest={() =>
            updateState({
              photoIndex:
                (state.photoIndex + pendingMatches.length - 1) %
                pendingMatches.length,
            })
          }
          onMoveNextRequest={() =>
            updateState({
              photoIndex: (state.photoIndex + 1) % pendingMatches.length,
            })
          }
        />
      )}
      {chooserModal()}
    </div>
  );
};

const mapStateToProps = ({ CigarManager }) => ({ CigarManager });

export default connect(mapStateToProps, {
  getAllCigars,
  getCigarMatches,
  getCigarMatchById,
})(CigarMatches);
